import { Editor, Node } from 'slate';
import { HistoryEditor } from 'slate-history';

import * as serializer from 'basic-editor-value-serializer';

import { readItemBreakpoint, readItemSize, saveItemSettings, writeItemSettings } from './settings';

const layoutUtilities = serializer.utilities.node.layout;

// Spec 3.11: gap handles show on a row that doesn't wrap and has Items per row set to Auto.
export function canResizeGaps(layoutNode, breakpoint) {

  const settings = layoutUtilities.resolveSettings(layoutNode)[breakpoint];

  return layoutUtilities.isRowDirection(settings.direction) && settings.wrap === 'nowrap' && settings.itemsPerRow === null && layoutNode.children.length > 1;

}

export function readGapItemSize(layoutNode, index, breakpoint) {
  return readItemSize(readItemBreakpoint(layoutNode, layoutNode.children[index], breakpoint).values);
}

function withItemSize(child, breakpoint, changes) {
  return { ...child, properties: { ...child.properties, layoutItem: writeItemSettings(child, breakpoint, changes) } };
}

// The cell variables an item would get, for showing a drag before it is saved.
export function previewCellStyle(layoutNode, index, breakpoint, changes) {

  const child = withItemSize(layoutNode.children[index], breakpoint, changes);

  return layoutUtilities.getCellStyleObject(layoutUtilities.resolveSettings(layoutNode), child);

}

// A drag that ends where it started writes nothing, so it leaves no empty undo step.
function changesSize(layoutNode, index, breakpoint, changes) {

  const resolvedLayout = layoutUtilities.resolveSettings(layoutNode);
  const child = layoutNode.children[index];
  const before = layoutUtilities.resolveItemSettings(resolvedLayout, child)[breakpoint];
  const after = layoutUtilities.resolveItemSettings(resolvedLayout, withItemSize(child, breakpoint, changes))[breakpoint];

  return JSON.stringify(before) !== JSON.stringify(after);

}

function writeSizes(editor, layoutPath, breakpoint, changes) {

  const layoutNode = Node.get(editor, layoutPath);
  const indexes = Object.keys(changes);

  Editor.withoutNormalizing(editor, function resize() {

    for (let index = 0; index < indexes.length; index++) {
      const childIndex = Number(indexes[index]);
      if (changesSize(layoutNode, childIndex, breakpoint, changes[indexes[index]]) === true) {
        const path = layoutPath.concat(childIndex);
        saveItemSettings(editor, path, writeItemSettings(Node.get(editor, path), breakpoint, changes[indexes[index]]));
      }
    }

  });

}

// changes: { [childIndex]: item size changes }. Both items change in one undo step, and a new
// one: a quick drag would otherwise join the step before it.
export function resizeGap(editor, layoutPath, breakpoint, changes) {

  HistoryEditor.withNewBatch(editor, function resize() {
    writeSizes(editor, layoutPath, breakpoint, changes);
  });

}
